import InputPrimary from "../Input";
import { useTranslation } from "react-i18next";

export default function InputConfirmNewPass({
  confirmPassValue,
  setConfirmPassValue,
}) {
  const { t } = useTranslation();
  const handleChange = (e) => {
    setConfirmPassValue(e.target.value);
  };
  return (
    <InputPrimary
      placeholder={t("confirm_new_pass")}
      value={confirmPassValue}
      onChange={handleChange}
      type="password"
    />
  );
}
